export default class DialysNurseFrom{
    recipeId:number
    recordTime:any = new Date()
    systolicPressure:number
    diastolicPressure:number
    transmembranePressure:number
    respiratoryRate:number
    heartRate:number
    bfv:number
    venousPressure:number
    arterialPressure:number
    conductivity:number
    ufv:number
    heparin:number
    ufr:number
    diaFlow:number
    diaTemperature:number
    patientVaEvent:PatientVaEvent = new PatientVaEvent()
    remarks:string
}
class PatientVaEvent {
    inputDate = new Date()
    patientId:null
    patientVAId:null
    complication:null
    declare:string
    imagePath:any
    remarks:string
    items:any
}


// WEBPACK FOOTER //
// ./src/views/dialysisProcess/dialysisArea/dialysisNurseForm.ts